<section class="equipo" aria-label="Hoy en el equipo">
  <header class="equipo__cabecera">
    <div>
      <span class="equipo__eyebrow">Hoy en el equipo</span>
      <h2 *ngIf="fecha">{{ fecha | date: "EEEE d 'de' MMMM" }}</h2>
      <p *ngIf="!cargando && !fallo">
        <ng-container *ngIf="fueraHoy === 0">Todo el equipo está hoy.</ng-container>
        <ng-container *ngIf="fueraHoy === 1">Una persona no está hoy.</ng-container>
        <ng-container *ngIf="fueraHoy > 1">{{ fueraHoy }} personas no están hoy.</ng-container>
      </p>
    </div>

    <nav class="equipo__accesos" *ngIf="puedeVerCalendario || puedeVerMonitoreo">
      <a *ngIf="puedeVerCalendario" routerLink="/admin/vacaciones/calendario">
        <mat-icon>calendar_month</mat-icon>
        <span>Calendario</span>
      </a>
      <a *ngIf="puedeVerMonitoreo" routerLink="/asistencia/monitoreo">
        <mat-icon>where_to_vote</mat-icon>
        <span>Asistencia de hoy</span>
      </a>
    </nav>
  </header>

  <p class="equipo__aviso" *ngIf="fallo">
    No se pudo consultar quién está hoy.
    <button type="button" (click)="consultar()">Reintentar</button>
  </p>

  <div class="equipo__columnas" *ngIf="!fallo">
    <article class="equipo__columna" *ngFor="let columna of columnas" [class.equipo__columna--vacia]="columna.personas.length === 0">
      <h3>
        <mat-icon>{{ columna.icono }}</mat-icon>
        <span>{{ columna.titulo }}</span>
        <em *ngIf="columna.personas.length">{{ columna.personas.length }}</em>
      </h3>

      <ul *ngIf="columna.personas.length; else vacio">
        <li *ngFor="let persona of columna.personas" [class.equipo__hoy]="esHoy(columna, persona)">
          <span class="equipo__nombre">{{ persona.nombre }}</span>
          <span class="equipo__detalle">{{ detalleDe(columna, persona) }}</span>
        </li>
      </ul>
      <ng-template #vacio>
        <p class="equipo__vacio">{{ cargando ? "Consultando…" : columna.vacio }}</p>
      </ng-template>
    </article>
  </div>
</section>
